import StorageService from './storage';

function isAuthenticated() {
  const auth = StorageService.get('auth');
  return (auth && auth.token);
}

function get() {
  if (isAuthenticated()) return StorageService.get('auth');
}

function create({ token }) {
  StorageService.set('auth', { token });
}

function reset() {
  StorageService.reset('auth');
}

export default {
  get,
  isAuthenticated,
  create,
  reset,
};
